var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"w-block__post-toolbar-1"},[(_vm.$route.name === 'index')?_c('v-container',{staticClass:"pa-4"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }